import React from "react"
import { Heading, Text } from "@atoms"
import { theme } from "@theme"
import cardPlaceholderImg from "./card-placeholder.jpg"
import { CardContainer, ImageWrapper } from "./styles/NewsAwardCard.styled"
import OptimizedImage from "../../utils/optimizedImage"
import { ConditionalWrapper } from "../../atoms/ConditionalWrapper"

function truncate(input) {
  if (input.length > 105) {
    return input.substring(0, 105) + "..."
  }
  return input
}

export const NewsAwardCard = ({ title, description, featuredImg, gatsbyImage, link }) => {
  return (
    <ConditionalWrapper
      condition={link}
      wrapper={children => (
        <a href={link} target="_blank" rel="noopener noreferrer"  style={{ display: "block", padding: "0px", textDecoration: "none" }}>
          {children}
        </a>
      )}
    >
      <CardContainer data-comp={NewsAwardCard.displayName} theme={theme}>
        {title && (
          <Heading
            headingSize="H6"
            style={{
              paddingBottom: "8px",
              textAlign: "center",
            }}
          >
            {title}
          </Heading>
        )}
        {description && (
          <Text style={{ textAlign: "center" }}>{truncate(description)}</Text>
        )}
        <ImageWrapper>
          <OptimizedImage
            alt='award logo'
            image={gatsbyImage}
            src={featuredImg || cardPlaceholderImg}
          />
        </ImageWrapper>
      </CardContainer>
    </ConditionalWrapper>
  )
}

NewsAwardCard.displayName = "NewsAwardCard"
